var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 15 14",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.8734 12.8332H14.0016V14H9.91779L9.33439 13.4166V9.33274H10.5012V11.6664C11.547 10.8817 12.2989 9.7685 12.6363 8.50535C12.9737 7.2422 12.877 5.90233 12.3618 4.7007C11.8466 3.49907 10.9426 2.50533 9.79503 1.87892C8.64743 1.25251 7.32267 1.02973 6.03331 1.24633C4.74394 1.46294 3.5647 2.10636 2.68478 3.07338C1.80486 4.04039 1.27526 5.27495 1.18096 6.57898C1.08665 7.88301 1.4331 9.18092 2.16473 10.2645C2.89635 11.348 3.97074 12.1544 5.21553 12.5543L4.86315 13.6675C3.35256 13.1831 2.05126 12.2 1.17244 10.8794C0.293606 9.55871 -0.110646 7.97874 0.025904 6.39828C0.162454 4.81782 0.831711 3.33059 1.92403 2.18024C3.01636 1.02988 4.46698 0.284604 6.03826 0.0664978C7.60954 -0.151608 9.20831 0.170389 10.5727 0.97974C11.937 1.78909 12.986 3.03781 13.5479 4.52132C14.1097 6.00483 14.1511 7.63518 13.6652 9.14528C13.1793 10.6554 12.195 11.9557 10.8734 12.8332V12.8332Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.68f093d11bea3a390c70c813b43a5fbe.svg";
export { ForwardRef as ReactComponent };